import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import Map from '../views/map'

export const Route = createFileRoute('/map/{-$mode}')({
  component: RouteComponent,
})

export default function RouteComponent() {
  const { mode } = Route.useParams();
  const search = Route.useSearch() as { mode?: string; v?: string; k?: string };
  return <Map mode={mode || "full"} search={search} />;
}
